import React, { useState, useEffect, useRef, Fragment } from 'react';
import moment from 'moment';
import _ from 'lodash';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import ContainerReport from '../../../ContainerReport';
import iconData from '../../../../../../assets/images/data.svg';
import { getBotMessagesByChannel } from '../../../../../../store/actions/reports';
import {
  getFilterPeriodType,
  updateChartXCategories,
  getTotalGraphic,
} from '../../graphic-report-helper';

const CHART_INITIAL_STATE = {
  chart: {
    type: 'column',
    width: 850,
    height: 250,
    style: {
      fontFamily: 'Fira Sans',
    },
  },

  title: {
    text: '',
  },

  xAxis: {
    categories: [],
  },

  yAxis: {
    allowDecimals: false,
    min: 0,
    title: {
      text: '',
    },
  },

  tooltip: {
    useHTML: true,
    opacity: 1,
    backgroundColor: '#2B323D',
    borderColor: '#2B323D',
    borderRadius: 10,
    formatter() {
      if (this.y <= 0) {
        return false;
      }
      return `<table style="color: white;"><tr><td style="text-align: center;">${this.x}</td></tr><tr><td style="text-align: center; color: white;">${this.y}</td></tr><tr><td style="text-align: center; color: white;">${this.series.name}</td></tr></table>`;
    },
  },

  plotOptions: {
    column: {
      stacking: 'normal',
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    align: 'left',
    x: 20,
  },
  series: [
    {
      name: 'Webchat',
      data: [],
      stack: 'male',
      color: '#FFAA00',
    },
    {
      name: 'Whatsapp',
      data: [],
      stack: 'male',
      color: '#13E676',
    },
    {
      name: 'Messenger',
      data: [],
      stack: 'male',
      color: '#1491FC',
    },
    // {
    //   name: 'Telegram',
    //   data: [],
    //   stack: 'male',
    //   color: '#C8DAEA',
    // },
    // {
    //   name: 'Email',
    //   data: [],
    //   stack: 'male',
    //   color: '#FEAA26',
    // },
  ],
  exporting: {
    enabled: false,
  },
};

/**
 * Component for show the graphic on the bot message by channel report
 *
 * @param {*} props
 * @returns
 */
const QntMessageChannelGraphic = (props) => {
  const {
    match,
    user,
    getBotMessagesByChannel,
    messagesByChannel,
    componentData,
    getRefGraphic,
    bot,
  } = props;

  const { parentFilter, draggableId, onRemoveClick, isEditMode } =
    componentData;

  const { botid } = match.params;
  const { startDate, endDate } = parentFilter;
  const token = user ? user.dashboard_token : '';

  /** Object for configuration the Highcharts graphic */
  const [chartOptions, setChartOptions] = useState(CHART_INITIAL_STATE);
  const [timezone, setTimezone] = useState('');
  const refChartContainer = useRef(null);

  useEffect(() => {
    getRefGraphic(refChartContainer);
  });

  /**
   * Called for fetch new data for this component
   */

  useEffect(() => {
    if (bot && bot.settings && bot.settings.timezone) {
      setTimezone(bot.settings.timezone.fuso);
    }
  }, [bot]);

  useEffect(() => {
    if (user && timezone !== '') {
      const { nameTags, channels, variables } = parentFilter;
      getBotMessagesByChannel(botid, token, {
        startDate,
        endDate,
        tags: nameTags,
        channels,
        variables,
        timezone,
      });
    }
  }, [parentFilter, user, timezone]);

  useEffect(() => {
    if (bot && bot.settings && bot.settings.timezone) {
      setTimezone(bot.settings.timezone.fuso);
    }
  }, [bot]);

  /**
   * Called for render the component and change values on UI
   */
  useEffect(() => {
    updateChart();
  }, [messagesByChannel]);

  // remove elementos repetidos do array
  const removeRepeat = (array) => {
    return array
      .map((el) => JSON.stringify(el))
      .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
      .map((el) => JSON.parse(el));
  };

  const newUpdateChartSeries = (byChannel) => {
    // cria um array de categorias
    let categories = byChannel.map((category) => {
      return category._id;
    });
    categories = removeRepeat(categories);

    // cria a estrutura das series
    let series = byChannel.map((channel) => {
      // cria o array com os valores do data de acordo com a categoria
      const data = categories.map((category) => {
        const result = byChannel.find((el) => {
          return el._id === category && el.channel === channel.channel;
        });
        return result ? result.count : 0;
      });

      const color =
        (channel.channel === 'webchat' && '#FFAA00') ||
        (channel.channel === 'whatsapp' && '#13E676') ||
        '#1491FC';

      return { name: channel.channel, data, stack: 'male', color };
    });
    series = removeRepeat(series);

    return series;
  };

  /**
   * Update chart when some information change
   */
  const updateChart = () => {
    const difference = moment.duration(
      moment(endDate.toString()).diff(moment(startDate.toString()))
    );
    const period = getFilterPeriodType(difference);
    const categories = updateChartXCategories(
      period,
      _.pickBy(messagesByChannel, _.identity)
    );

    // const series = updateChartSeries(period, categories);

    const series = newUpdateChartSeries(messagesByChannel);

    const chart = {
      ...chartOptions,
      series,
      xAxis: {
        categories,
      },
    };

    setChartOptions(chart);
  };

  /**
   * Update the series property from the chart options object
   * @param {string} period
   */
  const updateChartSeries = (period, categories) => {
    const series = [];
    _.forEach(chartOptions.series, (element) => {
      const newElement = _.cloneDeep(element);

      const newData = _.map(
        getCurrentGraphicData(newElement.name, period, categories),
        'count'
      );

      newElement.data = newData;

      series.push(newElement);
    });
    return series;
  };

  /**
   * Get the channel data array
   * @param {string} channel
   */
  const getChannelMessages = (channel) => {
    return _.filter(
      messagesByChannel,
      (message) => message.channel === channel
    );
  };

  /**
   * Get the current graphic data for the array iterator
   * @param {string} type
   * @param {string} period
   */
  const getCurrentGraphicData = (type, period, cat) => {
    switch (type) {
      case 'Whatsapp':
        console.log("getChannelMessages('whatsapp')");
        console.log(getChannelMessages('whatsapp'));

        return getTotalGraphic(getChannelMessages('whatsapp'), period, cat);
      case 'Messenger':
        return getTotalGraphic(getChannelMessages('messenger'), period, cat);
      case 'Webchat':
        return getTotalGraphic(getChannelMessages('webchat'), period, cat);
      default:
        return [];
    }
  };

  /**
   * Render report container content for the current report component
   */
  const renderContainerContent = () => {
    return (
      <HighchartsReact
        ref={refChartContainer}
        highcharts={Highcharts}
        options={chartOptions}
        allowChartUpdate
      />
    );
  };

  return (
    <ContainerReport
      type="graphic"
      icon={iconData}
      title="Quantidade de mensagens"
      containerContent={renderContainerContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
    />
  );
};

const mapStateToProps = (state) => ({
  user: state.users.signedUser,
  filter: state.filter,
  messagesByChannel: state.reports.botMessagesByChannel,
  bot: state.bots.bot,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getBotMessagesByChannel }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(QntMessageChannelGraphic)
);
